module.exports = __webpack_public_path__ + "img/15.eced3a80.jpg";